///**
// * @author      Abdul Pathan
// * @date        Aug, 2024
// * @copyright   www.ibirdsservices.com
// */
//import React, { useEffect, useRef, useState } from 'react'
//import { Button, Card, Col, Container, Form, Image, Row, Table, OverlayTrigger, Popover } from 'react-bootstrap'
//import WhatsAppAPI from "../../../api/schoolApi";
//import { ToastContainer, toast } from 'react-toastify'; // npm i react-toastify --force
//import 'react-toastify/dist/ReactToastify.css';
//import { useNavigate } from 'react-router-dom';
//
//const MarketingTemplate = ({ previewData, selectedWhatsAppSetting }) => {
//    const initialFormData = {
//        id: '',
//        name: '',
//        templatename: '',
//        language: '',
//        status: '',
//        category: '',
//        header: '',
//        header_text: '',
//        header_image_url: '',
//        header_document_url: '',
//        header_video_url: '',
//        message_body: '',
//        footer: '',
//        buttons: []
//    };
//
//    const navigate = useNavigate();
//    const [isSending, setIsSending] = useState(false);
//    const [isSpinner, setIsSpinner] = useState(false);
//    const [rowData, setRowData] = useState(initialFormData);
//    const [buttons, setButtons] = useState([]);
//    // file
//    const [selectedFiles, setSelectedFiles] = useState();
//    const [errorMessage, setErrorMessage] = useState('');
//    const [selectedImage2, setSelectedImage2] = useState();
//    const [selectedDocument2, setSelectedDocument2] = useState();
//    const [selectedVideo2, setSelectedVideo2] = useState();
//
//    const bodyRef = useRef(null);
//    const [variables, setVariables] = useState([]);
//
//    useEffect(() => {
//        if (previewData && previewData?.category === 'MARKETING') {
//            const exampleBodyText = previewData.example_body_text[0] || []; // Extract the first example (if exists)
//
//
//      const expectedMaxPlaceholder = exampleBodyText.length;
//
//
//      const updatedExamples = Array.from(
//        { length: expectedMaxPlaceholder },
//        (_, index) => ({
//          placeholder: index + 1,
//          value: exampleBodyText[index] || "", 
//        })
//      );
//
//
//      setRowData((prevData) => ({
//        ...prevData,
//        message_body: rowData.message_body,
//        message_body_example: updatedExamples,
//      }));
//
//            const buttons = previewData?.buttons && previewData.buttons.length > 0
//                ? previewData.buttons.map(button => ({
//                    type: button.type,
//                    text: button.text,
//                    ...(button.type === 'PHONE_NUMBER' && { phone_number: button.phone_number }),
//                    ...(button.type === 'URL' && { url: button.url }),
//                    ...(button.type === 'QUICK_REPLY' && { text: button.text }),
//                }))
//                : [];
//
//
//            setRowData({
//                id: previewData?.id || '',
//                name: previewData?.templatename || '',
//                language: previewData?.language || '',
//                status: previewData?.status || '',
//                category: previewData?.category || '',
//                header: previewData?.header || '',
//                header_text: previewData?.header_text || '',
//                header_image_url: previewData?.header_image_url || '',
//                header_document_url: previewData?.header_document_url || '',
//                header_video_url: previewData?.header_video_url || '',
//                message_body: previewData?.message_body || '',
//                message_body_example:updatedExamples || null,
//                footer: previewData?.footer || '',
//                buttons
//            });
//
//            setButtons(buttons)
//            setSelectedImage2(previewData?.header_image_url || null);
//            setSelectedDocument2(previewData?.header_document_url || null);
//            setSelectedVideo2(previewData?.header_video_url || null);
//            // setSelectedFiles(previewData?.header_image_url || null)
//         
//        } else {
//            setRowData(initialFormData);
//            setButtons([]);
//            setSelectedFiles(null);
//            setVariables([]);
//        }
//    }, [previewData]);
//    const addVariable = () => {
//      
//        const existingExamples = rowData?.message_body_example || [];
//       
//    
//        const newExample = {
//          placeholder: existingExamples.length + 1,
//          value: "",
//        };
//        const updatedExamples = [...existingExamples, newExample];
//        setRowData((prevData) => ({
//          ...prevData,
//          message_body_example: updatedExamples,
//          message_body:
//            `${prevData?.message_body} {{${existingExamples.length + 1}}} ` || "",
//        }));
//      };
//      useEffect(() => {
//        if (!rowData?.message_body)
//        {
//            setRowData((prevData) => ({
//                ...prevData,
//                
//                //message_body_example: null,
//              }));
//              return;
//        }
//    
//        //const textarea = bodyRef.current;
//        //const startPosition = textarea.selectionStart;
//        //const endPosition = textarea.selectionEnd;
//        const placeholders = Array.from(
//          new Set(rowData.message_body.match(/{{\d+}}/g) || [])
//        ).map((val) => parseInt(val.match(/\d+/)[0]));
//       
//    
//        if (placeholders.length > 0) {
//          placeholders.sort((a, b) => a - b);
//    
//          const maxPlaceholder = Math.max(...placeholders);
//          const expectedMaxPlaceholder = placeholders.length;
//    
//          if (maxPlaceholder !== expectedMaxPlaceholder) {
//            const placeholderMap = new Map(
//              placeholders.map((val, index) => [val, index + 1])
//            );
//            rowData.message_body = rowData.message_body.replace(
//              /{{\d+}}/g,
//              (match) =>
//                `{{${placeholderMap.get(parseInt(match.match(/\d+/)[0]))}}}`
//            );
//          }
//         
//         
//    
//          const existingExamples = rowData?.message_body_example || [];
//          const exampleMap = existingExamples.reduce((map, example) => {
//            map[example.placeholder] = example.value;
//            return map;
//          }, {});
//    
//          const updatedExamples = Array.from(
//            { length: expectedMaxPlaceholder },
//            (_, index) => ({
//              placeholder: index + 1,
//              value: exampleMap[index + 1] || "",
//            })
//          );
//    
//          setRowData((prevData) => ({
//            ...prevData,
//            message_body: rowData.message_body,
//            message_body_example: updatedExamples,
//          }));
//        //  setTimeout(() => {
//        //    textarea.selectionStart = startPosition + "{{}}".length;
//        //    textarea.selectionEnd = endPosition + "{{}}".length;
//        //    textarea.focus();
//        //}, 0);
//        //  setshowbody(true);
//        } else {
//            setRowData((prevData) => ({
//                ...prevData,
//                message_body_example: null,
//              }));
//        //  setshowbody(false);
//        }
//      }, [rowData?.message_body]);
//      
//    
//    const handleChange = (event) => {
//        const { name, value } = event.target;
//
//        const textarea = bodyRef.current;
//        const cursorPos = textarea.selectionStart;
//
//        let updatedValue = value;
//
//        if (name === 'message_body' && updatedValue==="") {            
//        setRowData(prevData => ({ ...prevData, message_body_example: null,}));            
//        }
//        setRowData(prevData => ({ ...prevData, [name]: updatedValue }));
//
//        if (name === 'header') {
//            setSelectedFiles(null)
//            setSelectedImage2(null);
//            setSelectedDocument2(null);
//            setSelectedVideo2(null);
//            setErrorMessage('');
//        }
//
//        setTimeout(() => {
//            textarea.selectionStart = textarea.selectionEnd = cursorPos;
//        }, 0);
//    }
//
//    const handleFileChange = (event) => {
//        const { name, files } = event.target;
//        const file = files[0];
//
//        if (!file) return;
//
//        const fileTypeMappings = {
//            header_image_url: ['jpg', 'jpeg', 'png'],
//            header_document_url: ['pdf'],
//            header_video_url: ['mp4']
//        };
//
//        const fileSize = {
//            header_image_url: 5,
//            header_document_url: 100,
//            header_video_url: 16
//        };
//
//        const validExtensions = fileTypeMappings[name];
//        if (!validExtensions.includes(file.name.split('.').pop().toLowerCase())) {
//            setErrorMessage(`Only ${validExtensions.join(', ')} files are allowed.`);
//            event.target.value = '';
//            return;
//        }
//
//        const validSize = fileSize[name];
//        if (file.size > validSize * 1024 * 1024) {
//            setErrorMessage(`Exceed maximum allowed upload size of ${validSize}MB.`);
//            event.target.value = '';
//            return;
//        }
//
//        setErrorMessage('');
//        switch (name) {
//            case 'header_image_url':
//                setSelectedImage2(null)
//                setSelectedFiles(file)
//                break;
//            case 'header_document_url':
//                setSelectedDocument2(null)
//                setSelectedFiles(file)
//                break;
//            case 'header_video_url':
//                setSelectedVideo2(null)
//                setSelectedFiles(file)
//                break;
//            default:
//                break;
//        }
//    };
//
//    const handleSubmit = async (event) => {
//        event.preventDefault();
//
//        if (rowData.header === 'TEXT' && !rowData.header_text.trim()) {
//            toast.error('Template header text is required.');
//            return;
//        }
//
//        if (rowData.header === 'IMAGE' && !selectedFiles && !selectedImage2) {
//            toast.error('Upload image is required.');
//            return;
//        }
//        if (rowData.header === 'DOCUMENT' && !selectedFiles && !selectedDocument2) {
//            toast.error('Upload document is required.');
//            return;
//        }
//        if (rowData.header === 'VIDEO' && !selectedFiles && !selectedVideo2) {
//            toast.error('Upload video mp4 is required.');
//            return;
//        }
//
//        if (buttons.length > 0) {
//            for (const button of buttons) {
//                if (button.type === 'URL' && (!button.text.trim() || !button.url.trim())) {
//                    toast.error('Please fill in all fields for the URL button.');
//                    return;
//                }
//                if (button.type === 'PHONE_NUMBER' && (!button.text.trim() || !button.phone_number.trim())) {
//                    toast.error('Please fill in all fields for the Phone Number button.');
//                    return;
//                }
//                if (button.type === 'QUICK_REPLY' && (!button.text.trim())) {
//                    toast.error('Please fill in all fields for the quick reply button.');
//                    return;
//                }
//            }
//        }
//
//        let imageId = ''
//
//        if (selectedFiles) {
//
//            const sessionId = await WhatsAppAPI.generateSessionId(selectedFiles, selectedWhatsAppSetting);
//
//
//            if (sessionId.id) {
//                const document = await WhatsAppAPI.uploadDocumentSessionId(selectedFiles, sessionId.id, selectedWhatsAppSetting);
//                imageId = document.h;
//
//            }
//        }
//
//        const formattedName = rowData.name.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
//
//        const reqBody = {
//            name: formattedName,
//            language: rowData.language,
//            category: 'MARKETING',
//            components: [
//                {
//                    type: 'HEADER',
//                    format: rowData.header,
//                    ...(rowData.header === 'TEXT' && { text: rowData.header_text }),
//                    ...(rowData.header === 'IMAGE' && { example: { header_handle: [imageId || rowData?.header_image_url] } }),
//                    ...(rowData.header === 'DOCUMENT' && { example: { header_handle: [imageId || rowData?.header_document_url] } }),
//                    ...(rowData.header === 'VIDEO' && { example: { header_handle: [imageId || rowData?.header_video_url] } }),
//                },
//                {
//                    type: 'BODY',
//                    text: rowData?.message_body,
//                    ...(rowData.message_body.match(/\{\{(\d+)\}\}/g)) && {
//                        example: {
//                            body_text: [
//                                Object.values(rowData?.message_body_example).map((data) => data.value)
//                            ]
//                        }
//                    }
//                    // ...(rowData.message_body.includes("{{1}}")) && {
//                    //     example: {
//                    //         body_text: [
//                    //             ["shivani mehra"]
//                    //         ]
//                    //     }
//                    // }
//                },
//                {
//                    type: 'FOOTER',
//                    text: rowData?.footer || '',
//                },
//                ...(buttons.filter(button => button.text && button.type).length > 0 ? [{
//                    type: 'BUTTONS',
//                    buttons: buttons.filter(button => button.text && button.type).map(button => ({
//                        type: button.type,
//                        text: button.text,
//                        ...(button.type === 'PHONE_NUMBER' && { phone_number: button.phone_number }),
//                        ...(button.type === 'URL' && { url: button.url }),
//                    })),
//                }] : []),
//            ],
//        };
//
//        try {
//            setIsSpinner(true)
//            let result;
//            if (rowData?.id) {
//                result = await WhatsAppAPI.updateMarketingTemplate(rowData.id, reqBody, selectedWhatsAppSetting);
//            } else {
//                result = await WhatsAppAPI.createMarketingTemplate(reqBody, selectedWhatsAppSetting);
//            }
//            // if (result.error) {
//            //     const errorJson = result.error.split(' - ')[1];
//            //     const parsedError = JSON.parse(errorJson);
//            //     const errorMessage = parsedError.error.error_user_msg || parsedError.error.message;
//            //     toast.error(errorMessage);
//            // }
//            if (result.error) {
//                const errorMessage = result.error.body || result.error.message || "An error occurred.";
//                toast.error(errorMessage);
//            } else {
//                toast.success(rowData?.id ? 'Template updated successfully.' : 'Template created successfully.');
//                setIsSpinner(false);
//                navigate('/whatsapp_template');
//            }
//        } catch (error) {
//            toast.error('An unexpected error occurred.');
//        } finally {
//            setIsSending(false);
//            setIsSpinner(false)
//        }
//    };
//
//    const handleBack = () => {
//        navigate("/Templates");
//    }
//
//    const handleRemoveButton = (index) => {
//        const updatedButtons = buttons.filter((_, i) => i !== index);
//        setButtons(updatedButtons);
//    };
//
//
//    const handleAddButton = () => {
//        const quickReplyCount = buttons.filter(button => button.type === 'QUICK_REPLY').length;
//        const hasPhone = buttons.some(button => button.type === 'PHONE_NUMBER');
//        const hasUrl = buttons.some(button => button.type === 'URL');
//
//        if (buttons.length < 5) {
//            if (!hasPhone && !hasUrl) {
//                const newButton = { type: 'PHONE_NUMBER', text: '', phone_number: '', url: '' };
//                setButtons([...buttons, newButton]);
//            } else if (!hasPhone && hasUrl) {
//                const newButton = { type: 'PHONE_NUMBER', text: '', phone_number: '', url: '' };
//                setButtons([...buttons, newButton]);
//            } else if (hasPhone && !hasUrl) {
//                const newButton = { type: 'URL', text: '', phone_number: '', url: '' };
//                setButtons([...buttons, newButton]);
//            } else {
//                if (quickReplyCount < 3) {
//                    const newQuickReplyButton = { type: 'QUICK_REPLY', text: '', phone_number: '', url: '' };
//                    setButtons([...buttons, newQuickReplyButton]);
//                } else {
//                    toast.error("Maximum of 3 Quick Reply buttons can be added.");
//                }
//            }
//        } else {
//            toast.error("Maximum of 5 buttons can be added.");
//        }
//    };
//
//    const handleButtonChange = (index, field, value) => {
//        const updatedButtons = buttons.map((button, i) => {
//            if (i === index) {
//                return { ...button, [field]: value };
//            }
//            return button;
//        });
//        setButtons(updatedButtons);
//    };
//
//    const getDisabledOptions = (currentType) => {
//        const hasPhone = buttons.some(button => button.type === 'PHONE_NUMBER');
//        const hasUrl = buttons.some(button => button.type === 'URL');
//        if ((currentType === 'PHONE_NUMBER' && hasPhone) || (currentType === 'URL' && hasUrl)) {
//            return true;
//        }
//        return false;
//    };
//    //const isFormValid = Boolean(rowData.name.trim()) && Boolean(rowData.language) && Boolean(rowData.message_body.trim()) && rowData.message_body.trim().length >= 25 && Boolean(rowData.footer.trim()) && Boolean(rowData?.example_body_text?.every(item => item.id && item.value));
//    // if (Array.isArray(rowData?.message_body_example)) {
//    //     console.log("Is every item valid? ",
//    //         rowData.message_body_example.every(item => 
//    //             Boolean(item?.placeholder) && 
//    //             typeof item?.value === "string" && 
//    //             Boolean(item?.value?.trim())
//    //         )
//    //     );
//    // } else {
//    //     console.log("example_body_text is not an array or is undefined");
//    // }
//    
//
//    //const isFormValid = 
//    //Boolean(rowData?.name?.trim()) &&
//    //Boolean(rowData?.language) &&
//    //Boolean(rowData?.message_body?.trim()) &&
//    //rowData?.message_body?.trim()?.length >= 25 &&
//    //Boolean(rowData?.footer?.trim()) &&(
//    //Array.isArray(rowData?.message_body_example) &&
//    //rowData?.message_body_example?.every(item => 
//    //    Boolean(item?.placeholder) && 
//    //    typeof item?.value === "string" && 
//    //    Boolean(item?.value?.trim()))
//    //)
//    const isFormValid = 
//    Boolean(rowData?.header?.trim()) &&
//    Boolean(rowData?.name?.trim()) &&
//    Boolean(rowData?.language) &&
//    Boolean(rowData?.message_body?.trim()) &&
//    rowData?.message_body?.trim()?.length >= 25 &&
//    Boolean(rowData?.footer?.trim()) &&
//    (
//        Array.isArray(rowData?.message_body_example) 
//        ? rowData.message_body_example.every(item => 
//            item && 
//            typeof item === "object" &&
//            "placeholder" in item &&
//            Boolean(item.placeholder) &&
//            "value" in item &&
//            typeof item.value === "string" &&
//            Boolean(item.value.trim())
//          )
//        : true 
//    );
//
//    const handleVariableChange = (id, newValue) => {
//        setVariables((prevValue) => prevValue.map((v) => v.id === id ? { ...v, value: newValue } : v));
//    }
//
//    // generate the next available variable number
////    const getNextVariableNumber = () => {
////        // const matches = rowData?.message_body?.match(/\{\{(\d+)\}\}/g) || [];
////        // const numbers = matches.map((match) => parseInt(match.replace(/[{}]/g, ""), 10));
////
////        const numbers = variables.map((v) => v.id);
////
////        const maxNumber = numbers.length > 0 ? Math.max(...numbers) : 0;
////        return maxNumber + 1;
////    };
//
//    const formatTextArea = (character) => {
//        if (!bodyRef.current) return;
//        let text = rowData?.message_body || '';
//        const textarea = bodyRef.current;
//        const startPosition = textarea.selectionStart;
//        const endPosition = textarea.selectionEnd;
//        //if (character !== null) {
//            character = character.trim();
//            const selectedText = text.substring(startPosition, endPosition);
//            const newText = text.substring(0, startPosition) + character + selectedText + character + text.substring(endPosition);
//            // console.log('newText: ', newText);
//            setRowData((prevData) => ({ ...prevData, message_body: newText }));
//
//            // Set cursor after inserted text
//            setTimeout(() => {
//                textarea.selectionStart = startPosition + character.length;
//                textarea.selectionEnd = endPosition + character.length;
//                textarea.focus();
//            }, 0);
////        } else {
////            let variableNumber = getNextVariableNumber();
////            character = ` {{${variableNumber}}}`;
////            const newText = text + character;
////            // console.log('newText: ', newText);
////            setRowData((prevData) => ({ ...prevData, message_body: newText }));
////
////            if (!variables.some((v) => v.id === variableNumber)) {
////                setVariables([...variables, { id: variableNumber, value: "" }])
////            }
////            // Set cursor after inserted variable
////            setTimeout(() => {
////                textarea.selectionStart = textarea.selectionEnd = newText.length;
////                textarea.focus();
////            }, 0);
////        }
//    }
//
//    // renumber variables sequentially
////    const renumberVariables = (updatedText) => {
////        const matches = updatedText.match(/\{\{(\d+)\}\}/g) || [];
////        // console.log('Re-match: ', matches);
////        // let count = 1;
////        // const newText = updatedText.replace(/\{\{(\d+)\}\}/g, () => `{{${count++}}}`);
////        // setVariables((prev) => { 
////        //     return matches.map((prevVariable, index) => { 
////        //         return `{{${index + 1}}}`; 
////        //     }) 
////        // });
////
////        const extractedNumbers = matches.map((match) => parseInt(match.replace(/[{}]/g, ""), 10));
////        console.log('extractedNumbers: ', extractedNumbers, variables);
////
////        // Filter existing variables & remove those missing in the textarea
////        const updatedVars = variables.filter((v) => extractedNumbers.includes(v.id));
////        console.log('updatedVars: ', updatedVars, updatedVars.sort((a, b) => a.id - b.id));
////        // Renumber variables sequentially
////        updatedVars.sort((a, b) => a.id - b.id).forEach((v, index) => (v.id = index + 1));
////        console.log('updatedVars2: ', updatedVars);
////
////        setVariables(updatedVars);
////
////        // Update textarea with renumbered variables
////        // let updatedText = rowData?.message_body;
////        matches.forEach((match, index) => {
////            updatedText = updatedText.replace(match, `{{${index + 1}}}`);
////        });
////        console.log('updatedText: ', updatedText);
////        return updatedText;
////    };
//
//    const helpText = (
//        <ul>
//            <li>Variable parameters are missing or have mismatched curly braces. The correct format is \u007B\u007B1\u007D\u007D.</li>
//            <li>Variable parameters contain special characters such as #, $, or %.</li>
//            <li>Variable parameters are not sequential. For example, \u007B\u007B1\u007D\u007D, \u007B\u007B2\u007D\u007D, \u007B\u007B4\u007D\u007D, \u007B\u007B5\u007D\u007D are defined but \u007B\u007B3\u007D\u007D does not exist.</li>
//            <li>Template contains too many variable parameters relative to the message length. You need to decrease the number of variable parameters or increase the message length.</li>
//            <li>The message template cannot end with a parameter.</li>
//        </ul>
//    );
//
//
//
//    return (
//        <>
//            {!isSpinner ? <>
//
//                <Container className='mt-1'>
//                    <Row className='mx-5 g-0'>
//                        <Col lg={12} sm={12} xs={12}>
//                            <Card className='h-100' style={{ border: "none" }}>
//                                <Card.Body>
//                                    <Row>
//                                        <Col lg={12} sm={12} xs={12}>
//                                            <Form.Group className='mx-2 mb-3'>
//                                                <Form.Label className="form-view-label" htmlFor="formBasicName">
//                                                    <b>Template name and language</b>
//                                                </Form.Label>
//                                            </Form.Group>
//                                        </Col>
//                                    </Row>
//
//                                    <Row className='mb-3'>
//                                        <Col lg={6} sm={12} xs={12}>
//                                            <Form.Group className='mx-2 mb-3'>
//                                                <Form.Label className="form-view-label" htmlFor="formBasicTemplateName">
//                                                    Template Name
//                                                </Form.Label>
//                                                <Form.Control
//                                                    disabled={rowData?.id}
//                                                    type="text"
//                                                    name="name"
//                                                    value={rowData?.name}
//                                                    onChange={(e) => {
//                                                        e.target.value = e.target.value.toLowerCase(); 
//                                                        handleChange(e); 
//                                                    }}
//                                                    placeholder="Enter template name"
//                                                    required
//                                                    style={{ height: "36px" }}
//                                                />
//                                            </Form.Group>
//                                        </Col>
//
//                                        <Col lg={6} sm={12} xs={12}>
//                                            <Form.Group className='mb-2 mx-3'>
//                                                <Form.Label className="form-view-label" htmlFor="formBasicLanguage">
//                                                    Language
//                                                </Form.Label>
//                                                <Form.Select
//                                                    // disabled={rowData?.id}
//                                                    aria-label="select language"
//                                                    name="language"
//                                                    value={rowData?.language}
//                                                    onChange={handleChange}
//                                                    required
//                                                    style={{ height: "36px" }}
//                                                >
//                                                    <option value="">Select Language</option>
//                                                    <option value="en">English</option>
//                                                    <option value="en_US">English (US)</option>
//                                                    <option value="en_GB">English (UK)</option>
//                                                    <option value="hi">Hindi</option>
//                                                    <option value="ur">Urdu</option>
//                                                </Form.Select>
//                                            </Form.Group>
//                                        </Col>
//                                    </Row>
//                                </Card.Body>
//                            </Card>
//                        </Col>
//                    </Row >
//                </Container >
//
//                <Container className='mt-1'>
//                    <Row className='mx-5 mb-5 g-0'>
//                        <Col lg={12} sm={12} xs={12} className="mb-2">
//                            <Card className='h-100' style={{ border: "none" }}>
//                                <Card.Body>
//                                    <Row>
//                                        <Col lg={12} sm={12} xs={12}>
//                                            <Form.Group className='mx-2 mb-3' >
//                                                <Form.Label className="form-view-label" htmlFor="formBasicContent">
//                                                    <b>Content </b> ( Fill in the header, body and footer sections of your template. )
//                                                </Form.Label>
//                                            </Form.Group>
//                                        </Col>
//                                    </Row>
//
//                                    <Row className='mb-3'>
//                                        <Col lg={6} sm={12} xs={12}>
//                                            <Form.Group className='mb-3 mx-3'>
//                                                <Form.Label className="form-view-label" htmlFor="formBasicHeader">
//                                                    Header
//                                                </Form.Label>
//                                                <Form.Select
//                                                    aria-label="select language"
//                                                    name="header"
//                                                    value={rowData?.header}
//                                                    onChange={handleChange}
//                                                    style={{ height: "36px" }}
//                                                >
//                                                    <option value="">Select Header</option>
//                                                    <option value="TEXT">Text</option>
//                                                    <option value="IMAGE">Image</option>
//                                                    <option value="DOCUMENT">Document</option>
//                                                    <option value="VIDEO">Video</option>
//                                                </Form.Select>
//                                            </Form.Group>
//                                        </Col>
//
//                                        {rowData.header === 'TEXT' &&
//                                            <Col lg={6} sm={12} xs={12}>
//                                                <Form.Group className='mx-2 mb-3'>
//                                                    <Form.Label className="form-view-label" htmlFor="formBasicHeaderText">
//                                                        Header Text
//                                                    </Form.Label>
//                                                    <Form.Control
//                                                        type="text"
//                                                        name="header_text"
//                                                        value={rowData?.header_text}
//                                                        onChange={handleChange}
//                                                        placeholder="Enter text here..."
//                                                        required
//                                                        style={{ height: "36px" }}
//                                                    />
//                                                </Form.Group>
//                                            </Col>
//                                        }
//                                    </Row>
//
//                                    <Row className='mb-3'>
//                                        <Col lg={6} sm={12} xs={12}>
//                                            {rowData.header === 'IMAGE' &&
//                                                <>
//                                                    <Form.Group className='mb-3 mx-3'>
//                                                        <Form.Label>Upload Image</Form.Label> <Form.Text muted>(Image Supported: .jpg, .jpeg, .png)</Form.Text>
//                                                        <Form.Control
//                                                            required
//                                                            type="file"
//                                                            name="header_image_url"
//                                                            accept="image/jpeg, image/png, image/jpg" // Allow only image files
//                                                            onChange={handleFileChange}
//                                                        />
//                                                        <Form.Text>Maximum Size: 5MB</Form.Text>
//                                                        {errorMessage && <><br /><Form.Text className="text-danger">{errorMessage}</Form.Text></>}
//                                                    </Form.Group>
//                                                    {selectedImage2 ?
//                                                        <Image className='mx-3' variant="top" src={selectedImage2} thumbnail style={{ width: "15%" }}>
//                                                        </Image>
//                                                        :
//                                                        selectedFiles &&
//                                                        <Image className='mx-3' variant="top" src={URL.createObjectURL(selectedFiles)} thumbnail style={{ width: "15%" }}>
//                                                        </Image>
//                                                    }
//                                                </>
//                                            }
//
//                                            {rowData.header === 'DOCUMENT' &&
//                                                <>
//                                                    <Form.Group className='mb-3 mx-3'>
//                                                        <Form.Label>Upload Document</Form.Label> <Form.Text muted>(Document Supported: .pdf)</Form.Text>
//                                                        <Form.Control
//                                                            required
//                                                            type="file"
//                                                            name="header_document_url"
//                                                            accept=".pdf" // Allow only PDF files
//                                                            onChange={handleFileChange}
//                                                        />
//                                                        <Form.Text>Maximum Size: 100MB</Form.Text>
//                                                        {errorMessage && <><br /><Form.Text className="text-danger">{errorMessage}</Form.Text></>}
//                                                    </Form.Group>
//
//                                                    {selectedDocument2 ?
//                                                        <Form.Text className="text-muted mx-2">
//                                                            <a href={selectedDocument2} target="_blank" rel="noopener noreferrer">
//                                                                <i className="fa-solid fa-file-pdf mx-2" style={{ fontSize: "15px" }}></i>View PDF
//                                                            </a>
//                                                        </Form.Text>
//                                                        :
//                                                        selectedFiles &&
//                                                        <Form.Text className="text-muted mx-2">
//                                                            <a href={URL.createObjectURL(selectedFiles)} target="_blank" rel="noopener noreferrer">
//                                                                <i className="fa-solid fa-file-pdf mx-2" style={{ fontSize: "15px" }}></i>{selectedFiles.name}</a>
//                                                        </Form.Text>
//                                                    }
//                                                </>
//                                            }
//
//                                            {rowData.header === 'VIDEO' &&
//                                                <>
//                                                    <Form.Group className='mb-3 mx-3'>
//                                                        <Form.Label>Upload Video</Form.Label> <Form.Text muted>(Video Supported: .mp4)</Form.Text>
//                                                        <Form.Control
//                                                            required
//                                                            type="file"
//                                                            name="header_video_url"
//                                                            accept="video/mp4" // Allow only MP4 videos
//                                                            onChange={handleFileChange}
//                                                        />
//                                                        <Form.Text>Maximum Size: 16MB</Form.Text>
//                                                        {errorMessage && <><br /><Form.Text className="text-danger">{errorMessage}</Form.Text></>}
//                                                    </Form.Group>
//                                                    {selectedVideo2 ?
//                                                        <video controls className='mx-3' style={{ width: "100%" }}>
//                                                            <source src={selectedVideo2} type="video/mp4" />
//                                                            Your browser does not support the video tag.
//                                                        </video>
//
//                                                        :
//                                                        selectedFiles &&
//                                                        <video controls className='mx-3' style={{ width: "100%" }}>
//                                                            <source src={URL.createObjectURL(selectedFiles)} type="video/mp4" />
//                                                            Your browser does not support the video tag.
//                                                        </video>
//                                                    }
//                                                </>
//                                            }
//                                        </Col>
//                                    </Row>
//
//                                    <Row className='mb-3'>
//                                        <Col lg={12} sm={12} xs={12}>
//                                            <Form.Group className='mx-3 mb-1'>
//                                                <Form.Label className="form-view-label" htmlFor="formBasicBody">
//                                                    Body <i className="fa-solid fa-circle-info mb-2" title="min length 25 characters."></i>
//                                                </Form.Label>
//                                                <Form.Control
//                                                    as="textarea"
//                                                    name="message_body"
//                                                    ref={bodyRef}
//                                                    value={rowData?.message_body}
//                                                    onChange={handleChange}
//                                                    placeholder="type text here..."
//                                                    required
//                                                    rows={10}
//                                                />
//                                            </Form.Group>
//                                            <div className='mb-3 mx-3'>
//                                                <Col lg={12} sm={12} xs={12} className='text-end mb-2'>
//                                                <div className="toolbar">
//                                                    <button className='format-text-btn' onClick={() => formatTextArea('*')} data-bs-toggle="tooltip" title="Bold"><i className="fa-solid fa-bold"></i></button>
//                                                    <button className='format-text-btn' onClick={() => formatTextArea('_')} data-bs-toggle="tooltip" title="Italic"><i className="fa-solid fa-italic"></i></button>
//                                                    <button className='format-text-btn' onClick={() => formatTextArea('~')} data-bs-toggle="tooltip" title="Strike-through"><i className="fa-solid fa-strikethrough"></i></button>
//                                                    <button className='format-text-btn' onClick={() => formatTextArea('```')} data-bs-toggle="tooltip" title="Monospace"><i className="fa-solid fa-code"></i></button>
//                                                       <button onClick={addVariable}  className='format-text-btn'>
//                                <i className="fa-solid fa-plus"></i> <span className='fw-bold ps-2'>Add variable</span>
//                              </button>
//
//                                                    {/*<button className='format-text-btn' onClick={() => formatTextArea(null)}><i className="fa-solid fa-plus"></i> <span className='fw-bold ps-2'>Add variable</span></button>*/}
//                                                    <OverlayTrigger
//                                                        placement="auto"
//                                                        overlay={
//                                                            <Popover id={`popover-positioned-auto`}>
//                                                                <Popover.Body>
//
//                                                                    <ul>
//                                                                        <li>Variable parameters are missing or have mismatched curly braces. The correct format is &#123;&#123;1&#125;&#125;.</li>
//                                                                        <li>Variable parameters should not contain special characters such as #, $, or %.</li>
//                                                                        <li>Variable parameters are not sequential. For example, &#123;&#123;1&#125;&#125;, &#123;&#123;2&#125;&#125;, &#123;&#123;4&#125;&#125;, &#123;&#123;5&#125;&#125; are defined but &#123;&#123;3&#125;&#125; does not exist.</li>
//                                                                        <li>Template contains too many variable parameters relative to the message length. You need to decrease the number of variable parameters or increase the message length.</li>
//                                                                        <li>The message template cannot end with a parameter.</li>
//                                                                    </ul>
//
//                                                                </Popover.Body>
//                                                            </Popover>
//                                                        }
//                                                    >
//                                                        <i className="fa-solid fa-circle-info text-secondary" style={{ cursor: "pointer" }}></i>
//                                                    </OverlayTrigger>
//                                                    </div>
//                                                </Col>
//
//                                                <Col xs={12}>
//                                                    {
//                                                        rowData?.message_body_example ?
//                                                            <Table>
//                                                                <thead>
//                                                                    <tr>
//                                                                        <th className='w-25'>Variable</th>
//                                                                        <th className='w-25'>Value</th>
//                                                                    </tr>
//                                                                </thead>
//                                                                <tbody>
//                                                                
//                                                                       {rowData?.message_body_example?.map(
//                                  (example, index) => (
//                                 <tr key={index}>
//                                                                                    <td>
//                                          {`{{${example.placeholder}}}`}
//                                        </td>
//                                      
//                                      
//                                       <td>
//                                        <Form.Control
//                                          required
//                                          type="text"
//                                          name={`${example.placeholder}.value`}
//                                          value={example.value || ""}
//                                          onChange={(e) => {
//                                            const updatedValue = e.target.value;
//                                            setRowData((prevData) => ({
//                                              ...prevData,
//                                              message_body_example:
//                                                prevData.message_body_example.map(
//                                                  (item) =>
//                                                    item.placeholder ===
//                                                    example.placeholder
//                                                      ? {
//                                                          ...item,
//                                                          value: updatedValue,
//                                                        }
//                                                      : item
//                                                ),
//                                            }));
//                                          }}
//                                          placeholder={`Enter content for {{${example.placeholder}}}`}
//                                        />
//                               </td>
//                                    </tr>
//                                  )
//                                )}
//                                                                </tbody>
//                                                            </Table>
//                                                            : ''
//                                                    }
//                                                </Col>
//                                              </div>
//                                              </Col>
//                                        <Col lg={6} sm={12} xs={12}>
//                                            <Form.Group className='mx-3 mb-3'>
//                                                <Form.Label className="form-view-label" htmlFor="formBasicFooter">
//                                                    Footer
//                                                </Form.Label>
//                                                <Form.Control
//                                                    required
//                                                    type="text"
//                                                    name="footer"
//                                                    value={rowData?.footer}
//                                                    onChange={handleChange}
//                                                    placeholder="type text here..."
//                                                    style={{ height: "36px" }}
//                                                />
//                                            </Form.Group>
//                                        </Col>
//                                    </Row>
//
//
//                                    <Row className='mb-1'>
//                                        <Col lg={12} sm={12} xs={12}>
//                                            <Button className='mb-3 mx-3' variant="outline-secondary" onClick={handleAddButton}>
//                                                <i className="fa-solid fa-plus mx-1"></i>Add Button
//                                            </Button>
//                                        </Col>
//                                    </Row>
//
//                                    <Row className='mb-1 mx-2'>
//                                        <Col lg={12} sm={12} xs={12} className="mb-2">
//                                            {buttons.map((button, index) => (
//                                                <Row key={index} className='mb-3'>
//                                                    <Col lg={3} sm={12} xs={12}>
//                                                        <Form.Group className='mb-0'>
//                                                            <Form.Label className="form-view-label">Type of action</Form.Label>
//                                                            <Form.Select
//                                                                value={button.type}
//                                                                onChange={(e) => handleButtonChange(index, 'type', e.target.value)}
//                                                                style={{ height: "36px" }}
//                                                            >
//                                                                <option value="">Select Type</option>
//                                                                <option value="URL" disabled={getDisabledOptions('URL') && button.type !== 'URL'}>Visit Website</option>
//                                                                <option value="PHONE_NUMBER" disabled={getDisabledOptions('PHONE_NUMBER') && button.type !== 'PHONE_NUMBER'}>Call Phone Number</option>
//                                                                <option value="QUICK_REPLY">Quick Reply</option>
//                                                            </Form.Select>
//                                                        </Form.Group>
//                                                    </Col>
//
//                                                    {(button.type === 'URL' || button.type === 'PHONE_NUMBER') && (
//                                                        <Col lg={3} sm={12} xs={12}>
//                                                            <Form.Group className='mb-0'>
//                                                                <Form.Label className="form-view-label">Button Text</Form.Label>
//                                                                <Form.Control
//                                                                    type="text"
//                                                                    value={button.text}
//                                                                    onChange={(e) => handleButtonChange(index, 'text', e.target.value)}
//                                                                    placeholder="Enter button text..."
//                                                                    style={{ height: "36px" }}
//                                                                />
//                                                            </Form.Group>
//                                                        </Col>
//                                                    )}
//
//                                                    {button.type === 'URL' && (
//                                                        <Col lg={3} sm={12} xs={12}>
//                                                            <Form.Group className='mb-0'>
//                                                                <Form.Label className="form-view-label">URL</Form.Label>
//                                                                <Form.Control
//                                                                    required
//                                                                    type="text"
//                                                                    value={button.url}
//                                                                    onChange={(e) => handleButtonChange(index, 'url', e.target.value)}
//                                                                    placeholder="https://www.example.com"
//                                                                    style={{ height: "36px" }}
//                                                                />
//                                                            </Form.Group>
//                                                        </Col>
//                                                    )}
//
//                                                    {button.type === 'PHONE_NUMBER' && (
//                                                        <Col lg={3} sm={12} xs={12}>
//                                                            <Form.Group className='mb-0'>
//                                                                <Form.Label className="form-view-label">Phone Number</Form.Label>
//                                                                <Form.Control
//                                                                    required
//                                                                    type="text"
//                                                                    value={button.phone_number}
//                                                                    onChange={(e) => handleButtonChange(index, 'phone_number', e.target.value.replace(/\D/g, ''))}
//                                                                    placeholder="16467043595"
//                                                                    style={{ height: "36px" }}
//                                                                />
//                                                            </Form.Group>
//                                                        </Col>
//                                                    )}
//
//                                                    {button.type === 'QUICK_REPLY' && (
//                                                        <Col lg={6} sm={12} xs={12}>
//                                                            <Form.Group className='mb-0'>
//                                                                <Form.Label className="form-view-label">Text</Form.Label>
//                                                                <Form.Control
//                                                                    required
//                                                                    type="text"
//                                                                    value={button.text}
//                                                                    onChange={(e) => handleButtonChange(index, 'text', e.target.value)}
//                                                                    placeholder="Enter button text..."
//                                                                    style={{ height: "36px" }}
//                                                                    maxLength={25}
//                                                                />
//                                                            </Form.Group>
//                                                        </Col>
//                                                    )}
//
//                                                    <Col lg={3} sm={12} xs={12} className='d-flex align-items-center mt-4 pt-2'>
//                                                        <Button variant='danger' onClick={() => handleRemoveButton(index)}>
//                                                            <i className="fa-solid fa-xmark" title='Remove'></i>
//                                                        </Button>
//                                                    </Col>
//                                                </Row>
//                                            ))}
//                                        </Col>
//                                    </Row>
//
//
//                                    <Row>
//                                        <Col lg={12} sm={12} xs={12}>
//                                            <hr></hr>
//                                        </Col>
//                                    </Row>
//
//                                    <Row className='g-0 mb-2'>
//                                        <Col lg={12} sm={12} xs={12} className="text-end mt-2">
//                                            <Button className='mx-2' variant="light" onClick={handleBack} disabled={isSending}>
//                                                Back
//                                            </Button>
//                                            <Button variant="outline-secondary" disabled={!isFormValid || isSending} onClick={handleSubmit}>
//                                                {isSending ? 'Submitting...' : 'Submit for Review'}
//                                            </Button>
//                                        </Col>
//                                    </Row>
//
//                                </Card.Body>
//                            </Card>
//                        </Col>
//                    </Row >
//                </Container >
//
//            </>
//                :
//                <Container className='mt-1'>
//                    <Row className='mx-5'>
//                        <Col lg={12} sm={12} xs={12}>
//                            <Card className='h-100' style={{ border: "none" }}>
//                                <Card.Body>
//                                    <Row className='mb-3'>
//                                        <Col lg={12} sm={12} xs={12}>
//                                            <div className="sk-cube-grid">
//                                                <div className="sk-cube sk-cube1"></div>
//                                                <div className="sk-cube sk-cube2"></div>
//                                                <div className="sk-cube sk-cube3"></div>
//                                                <div className="sk-cube sk-cube4"></div>
//                                                <div className="sk-cube sk-cube5"></div>
//                                                <div className="sk-cube sk-cube6"></div>
//                                                <div className="sk-cube sk-cube7"></div>
//                                                <div className="sk-cube sk-cube8"></div>
//                                                <div className="sk-cube sk-cube9"></div>
//                                            </div>
//                                        </Col>
//                                    </Row>
//                                </Card.Body>
//                            </Card>
//                        </Col>
//                    </Row >
//                </Container >
//            }
//
//            <ToastContainer />
//        </>
//    )
//}
//
//export default MarketingTemplate;
/**
 * @author      Abdul Pathan
 * @date        Aug, 2024
 * @copyright   www.ibirdsservices.com
 */
import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Col, Container, Form, Image, Row, Table, OverlayTrigger, Popover } from 'react-bootstrap'
import WhatsAppAPI from "../../../api/schoolApi";
import { ToastContainer, toast } from 'react-toastify'; // npm i react-toastify --force
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

const MarketingTemplate = ({ previewData, selectedWhatsAppSetting }) => {
    const initialFormData = {
        id: '',
        name: '',
        templatename: '',
        language: '',
        status: '',
        category: '',
        header: '',
        header_text: '',
        header_image_url: '',
        header_document_url: '',
        header_video_url: '',
        message_body: '',
        footer: '',
        buttons: []
    };

    const navigate = useNavigate();
    const [isSending, setIsSending] = useState(false);
    const [isSpinner, setIsSpinner] = useState(false);
    const [rowData, setRowData] = useState(initialFormData);
    const [buttons, setButtons] = useState([]);
    // file
    const [selectedFiles, setSelectedFiles] = useState();
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedImage2, setSelectedImage2] = useState();
    const [selectedDocument2, setSelectedDocument2] = useState();
    const [selectedVideo2, setSelectedVideo2] = useState();

    const bodyRef = useRef(null);
    const [variables, setVariables] = useState([]);

    useEffect(() => {
        if (previewData && previewData?.category === 'MARKETING') {
            const exampleBodyText = previewData.example_body_text[0] || []; // Extract the first example (if exists)


      const expectedMaxPlaceholder = exampleBodyText.length;


      const updatedExamples = Array.from(
        { length: expectedMaxPlaceholder },
        (_, index) => ({
          placeholder: index + 1,
          value: exampleBodyText[index] || "",
        })
      );


      setRowData((prevData) => ({
        ...prevData,
        message_body: rowData.message_body,
        message_body_example: updatedExamples,
      }));

            const buttons = previewData?.buttons && previewData.buttons.length > 0
                ? previewData.buttons.map(button => ({
                    type: button.type,
                    text: button.text,
                    ...(button.type === 'PHONE_NUMBER' && { phone_number: button.phone_number }),
                    ...(button.type === 'URL' && { url: button.url }),
                    ...(button.type === 'QUICK_REPLY' && { text: button.text }),
                }))
                : [];


            setRowData({
                id: previewData?.id || '',
                name: previewData?.templatename || '',
                language: previewData?.language || '',
                status: previewData?.status || '',
                category: previewData?.category || '',
                header: previewData?.header || '',
                header_text: previewData?.header_text || '',
                header_image_url: previewData?.header_image_url || '',
                header_document_url: previewData?.header_document_url || '',
                header_video_url: previewData?.header_video_url || '',
                message_body: previewData?.message_body || '',
                message_body_example:updatedExamples || null,
                footer: previewData?.footer || '',
                buttons
            });

            setButtons(buttons)
            setSelectedImage2(previewData?.header_image_url || null);
            setSelectedDocument2(previewData?.header_document_url || null);
            setSelectedVideo2(previewData?.header_video_url || null);
            // setSelectedFiles(previewData?.header_image_url || null)
         
        } else {
            setRowData(initialFormData);
            setButtons([]);
            setSelectedFiles(null);
            setVariables([]);
        }
    }, [previewData]);
    const addVariable = () => {
     
        const existingExamples = rowData?.message_body_example || [];
       
   
        const newExample = {
          placeholder: existingExamples.length + 1,
          value: "",
        };
        const updatedExamples = [...existingExamples, newExample];
        setRowData((prevData) => ({
          ...prevData,
          message_body_example: updatedExamples,
          message_body:
            `${prevData?.message_body} {{${existingExamples.length + 1}}} ` || "",
        }));
      };
      useEffect(() => {
        if (!rowData?.message_body)
        {
            setRowData((prevData) => ({
                ...prevData,
               
                //message_body_example: null,
              }));
              return;
        }
   
        //const textarea = bodyRef.current;
        //const startPosition = textarea.selectionStart;
        //const endPosition = textarea.selectionEnd;
        const placeholders = Array.from(
          new Set(rowData.message_body.match(/{{\d+}}/g) || [])
        ).map((val) => parseInt(val.match(/\d+/)[0]));
       
   
        if (placeholders.length > 0) {
          placeholders.sort((a, b) => a - b);
   
          const maxPlaceholder = Math.max(...placeholders);
          const expectedMaxPlaceholder = placeholders.length;
   
          if (maxPlaceholder !== expectedMaxPlaceholder) {
            const placeholderMap = new Map(
              placeholders.map((val, index) => [val, index + 1])
            );
            rowData.message_body = rowData.message_body.replace(
              /{{\d+}}/g,
              (match) =>
                `{{${placeholderMap.get(parseInt(match.match(/\d+/)[0]))}}}`
            );
          }
         
         
   
          const existingExamples = rowData?.message_body_example || [];
          const exampleMap = existingExamples.reduce((map, example) => {
            map[example.placeholder] = example.value;
            return map;
          }, {});
   
          const updatedExamples = Array.from(
            { length: expectedMaxPlaceholder },
            (_, index) => ({
              placeholder: index + 1,
              value: exampleMap[index + 1] || "",
            })
          );
   
          setRowData((prevData) => ({
            ...prevData,
            message_body: rowData.message_body,
            message_body_example: updatedExamples,
          }));
        //  setTimeout(() => {
        //    textarea.selectionStart = startPosition + "{{}}".length;
        //    textarea.selectionEnd = endPosition + "{{}}".length;
        //    textarea.focus();
        //}, 0);
        //  setshowbody(true);
        } else {
            setRowData((prevData) => ({
                ...prevData,
                message_body_example: null,
              }));
        //  setshowbody(false);
        }
      }, [rowData?.message_body]);
     
   
    const handleChange = (event) => {
        const { name, value } = event.target;

        const textarea = bodyRef.current;
        const cursorPos = textarea.selectionStart;

        let updatedValue = value;

        if (name === 'message_body' && updatedValue==="") {            
        setRowData(prevData => ({ ...prevData, message_body_example: null,}));            
        }
        setRowData(prevData => ({ ...prevData, [name]: updatedValue }));

        if (name === 'header') {
            setSelectedFiles(null)
            setSelectedImage2(null);
            setSelectedDocument2(null);
            setSelectedVideo2(null);
            setErrorMessage('');
        }

        setTimeout(() => {
            textarea.selectionStart = textarea.selectionEnd = cursorPos;
        }, 0);
    }

    const handleFileChange = (event) => {
        const { name, files } = event.target;
        const file = files[0];

        if (!file) return;

        const fileTypeMappings = {
            header_image_url: ['jpg', 'jpeg', 'png'],
            header_document_url: ['pdf'],
            header_video_url: ['mp4']
        };

        const fileSize = {
            header_image_url: 5,
            header_document_url: 100,
            header_video_url: 16
        };

        const validExtensions = fileTypeMappings[name];
        if (!validExtensions.includes(file.name.split('.').pop().toLowerCase())) {
            setErrorMessage(`Only ${validExtensions.join(', ')} files are allowed.`);
            event.target.value = '';
            return;
        }

        const validSize = fileSize[name];
        if (file.size > validSize * 1024 * 1024) {
            setErrorMessage(`Exceed maximum allowed upload size of ${validSize}MB.`);
            event.target.value = '';
            return;
        }

        setErrorMessage('');
        switch (name) {
            case 'header_image_url':
                setSelectedImage2(null)
                setSelectedFiles(file)
                break;
            case 'header_document_url':
                setSelectedDocument2(null)
                setSelectedFiles(file)
                break;
            case 'header_video_url':
                setSelectedVideo2(null)
                setSelectedFiles(file)
                break;
            default:
                break;
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (rowData.header === 'TEXT' && !rowData.header_text.trim()) {
            toast.error('Template header text is required.');
            return;
        }

        if (rowData.header === 'IMAGE' && !selectedFiles && !selectedImage2) {
            toast.error('Upload image is required.');
            return;
        }
        if (rowData.header === 'DOCUMENT' && !selectedFiles && !selectedDocument2) {
            toast.error('Upload document is required.');
            return;
        }
        if (rowData.header === 'VIDEO' && !selectedFiles && !selectedVideo2) {
            toast.error('Upload video mp4 is required.');
            return;
        }

        if (buttons.length > 0) {
            for (const button of buttons) {
                if (button.type === 'URL' && (!button.text.trim() || !button.url.trim())) {
                    toast.error('Please fill in all fields for the URL button.');
                    return;
                }
                if (button.type === 'PHONE_NUMBER' && (!button.text.trim() || !button.phone_number.trim())) {
                    toast.error('Please fill in all fields for the Phone Number button.');
                    return;
                }
                if (button.type === 'QUICK_REPLY' && (!button.text.trim())) {
                    toast.error('Please fill in all fields for the quick reply button.');
                    return;
                }
            }
        }

        let imageId = ''

        if (selectedFiles) {
            
            const sessionId = await WhatsAppAPI.generateSessionId(selectedFiles);


            if (sessionId.id) {
                const document = await WhatsAppAPI.uploadDocumentSessionId(selectedFiles, sessionId.id, selectedWhatsAppSetting);
                imageId = document.h;

            }
        }

        const formattedName = rowData.name.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
        // console.log(reqBody);
        // debugger;
        const reqBody = {
            name: formattedName,
            language: rowData.language,
            category: 'MARKETING',
            components: [
                ...(rowData.header ? [{
                    type: 'HEADER',
                    format: rowData.header,
                    ...(rowData.header === 'TEXT' && { text: rowData.header_text }),
                    ...(rowData.header === 'IMAGE' && { example: { header_handle: [imageId || rowData?.header_image_url] } }),
                    ...(rowData.header === 'DOCUMENT' && { example: { header_handle: [imageId || rowData?.header_document_url] } }),
                    ...(rowData.header === 'VIDEO' && { example: { header_handle: [imageId || rowData?.header_video_url] } })
                }] : []),
                {
                    type: 'BODY',
                    text: rowData?.message_body,
                    ...(rowData.message_body?.match(/\{\{(\d+)\}\}/g)) && {
                        example: {
                            body_text: [
                                Object.values(rowData?.message_body_example).map((data) => data.value)
                            ]
                        }
                    }
                },
                ...(rowData.footer ? [{
                    type: 'FOOTER',
                    text: rowData.footer
                }] : []),
                ...(buttons.filter(button => button.text && button.type).length > 0 ? [{
                    type: 'BUTTONS',
                    buttons: buttons.filter(button => button.text && button.type).map(button => ({
                        type: button.type,
                        text: button.text,
                        ...(button.type === 'PHONE_NUMBER' && { phone_number: button.phone_number }),
                        ...(button.type === 'URL' && { url: button.url }),
                    })),
                }] : []),
            ],
        };


        try {
            setIsSpinner(true)
            let result;
            if (rowData?.id) {
                result = await WhatsAppAPI.updateMarketingTemplate(rowData.id, reqBody, selectedWhatsAppSetting);
            } else {
                result = await WhatsAppAPI.createMarketingTemplate(reqBody, selectedWhatsAppSetting);
            }
            // if (result.error) {
            //     const errorJson = result.error.split(' - ')[1];
            //     const parsedError = JSON.parse(errorJson);
            //     const errorMessage = parsedError.error.error_user_msg || parsedError.error.message;
            //     toast.error(errorMessage);
            // }
            console.log("result",result);
            if (result?.success === false) {
                const errorTitle = result?.details?.error?.error_user_title || "Error";
                const errorMessage = result?.details?.error?.error_user_msg || result?.message || "An error occurred.";
                toast.error(`${errorTitle}: ${errorMessage}`);
            } else {
                toast.success(rowData?.id ? 'Template updated successfully.' : 'Template created successfully.');
                setIsSpinner(false);
                navigate('/Templates');
            }
        } catch (error) {
            toast.error('An unexpected error occurred.');
        } finally {
            setIsSending(false);
            setIsSpinner(false)
        }
    };

    const handleBack = () => {
                navigate("/Templates");
    }

    const handleRemoveButton = (index) => {
        const updatedButtons = buttons.filter((_, i) => i !== index);
        setButtons(updatedButtons);
    };


    const handleAddButton = () => {
        const quickReplyCount = buttons.filter(button => button.type === 'QUICK_REPLY').length;
        const hasPhone = buttons.some(button => button.type === 'PHONE_NUMBER');
        const hasUrl = buttons.some(button => button.type === 'URL');

        if (buttons.length < 5) {
            if (!hasPhone && !hasUrl) {
                const newButton = { type: 'PHONE_NUMBER', text: '', phone_number: '', url: '' };
                setButtons([...buttons, newButton]);
            } else if (!hasPhone && hasUrl) {
                const newButton = { type: 'PHONE_NUMBER', text: '', phone_number: '', url: '' };
                setButtons([...buttons, newButton]);
            } else if (hasPhone && !hasUrl) {
                const newButton = { type: 'URL', text: '', phone_number: '', url: '' };
                setButtons([...buttons, newButton]);
            } else {
                if (quickReplyCount < 3) {
                    const newQuickReplyButton = { type: 'QUICK_REPLY', text: '', phone_number: '', url: '' };
                    setButtons([...buttons, newQuickReplyButton]);
                } else {
                    toast.error("Maximum of 3 Quick Reply buttons can be added.");
                }
            }
        } else {
            toast.error("Maximum of 5 buttons can be added.");
        }
    };

    const handleButtonChange = (index, field, value) => {
        const updatedButtons = buttons.map((button, i) => {
            if (i === index) {
                return { ...button, [field]: value };
            }
            return button;
        });
        setButtons(updatedButtons);
    };

    const getDisabledOptions = (currentType) => {
        const hasPhone = buttons.some(button => button.type === 'PHONE_NUMBER');
        const hasUrl = buttons.some(button => button.type === 'URL');
        if ((currentType === 'PHONE_NUMBER' && hasPhone) || (currentType === 'URL' && hasUrl)) {
            return true;
        }
        return false;
    };
    //const isFormValid = Boolean(rowData.name.trim()) && Boolean(rowData.language) && Boolean(rowData.message_body.trim()) && rowData.message_body.trim().length >= 25 && Boolean(rowData.footer.trim()) && Boolean(rowData?.example_body_text?.every(item => item.id && item.value));
    // if (Array.isArray(rowData?.message_body_example)) {
    //     console.log("Is every item valid? ",
    //         rowData.message_body_example.every(item =>
    //             Boolean(item?.placeholder) &&
    //             typeof item?.value === "string" &&
    //             Boolean(item?.value?.trim())
    //         )
    //     );
    // } else {
    //     console.log("example_body_text is not an array or is undefined");
    // }
   

    //const isFormValid =
    //Boolean(rowData?.name?.trim()) &&
    //Boolean(rowData?.language) &&
    //Boolean(rowData?.message_body?.trim()) &&
    //rowData?.message_body?.trim()?.length >= 25 &&
    //Boolean(rowData?.footer?.trim()) &&(
    //Array.isArray(rowData?.message_body_example) &&
    //rowData?.message_body_example?.every(item =>
    //    Boolean(item?.placeholder) &&
    //    typeof item?.value === "string" &&
    //    Boolean(item?.value?.trim()))
    //)
    // const isFormValid = true;
    const isFormValid =
    // Boolean(rowData?.header?.trim()) &&
    Boolean(rowData?.name?.trim()) &&
    Boolean(rowData?.language) &&
    Boolean(rowData?.message_body?.trim()) &&
    rowData?.message_body?.trim()?.length >= 25 &&
    // Boolean(rowData?.footer?.trim()) &&
    (
        Array.isArray(rowData?.message_body_example)
        ? rowData.message_body_example.every(item =>
            item &&
            typeof item === "object" &&
            "placeholder" in item &&
            Boolean(item.placeholder) &&
            "value" in item &&
            typeof item.value === "string" &&
            Boolean(item.value.trim())
          )
        : true
    );

    const handleVariableChange = (id, newValue) => {
        setVariables((prevValue) => prevValue.map((v) => v.id === id ? { ...v, value: newValue } : v));
    }

    // generate the next available variable number
//    const getNextVariableNumber = () => {
//        // const matches = rowData?.message_body?.match(/\{\{(\d+)\}\}/g) || [];
//        // const numbers = matches.map((match) => parseInt(match.replace(/[{}]/g, ""), 10));
//
//        const numbers = variables.map((v) => v.id);
//
//        const maxNumber = numbers.length > 0 ? Math.max(...numbers) : 0;
//        return maxNumber + 1;
//    };

    const formatTextArea = (character) => {
        if (!bodyRef.current) return;
        let text = rowData?.message_body || '';
        const textarea = bodyRef.current;
        const startPosition = textarea.selectionStart;
        const endPosition = textarea.selectionEnd;
        //if (character !== null) {
            character = character.trim();
            const selectedText = text.substring(startPosition, endPosition);
            const newText = text.substring(0, startPosition) + character + selectedText + character + text.substring(endPosition);
            // console.log('newText: ', newText);
            setRowData((prevData) => ({ ...prevData, message_body: newText }));

            // Set cursor after inserted text
            setTimeout(() => {
                textarea.selectionStart = startPosition + character.length;
                textarea.selectionEnd = endPosition + character.length;
                textarea.focus();
            }, 0);
//        } else {
//            let variableNumber = getNextVariableNumber();
//            character = ` {{${variableNumber}}}`;
//            const newText = text + character;
//            // console.log('newText: ', newText);
//            setRowData((prevData) => ({ ...prevData, message_body: newText }));
//
//            if (!variables.some((v) => v.id === variableNumber)) {
//                setVariables([...variables, { id: variableNumber, value: "" }])
//            }
//            // Set cursor after inserted variable
//            setTimeout(() => {
//                textarea.selectionStart = textarea.selectionEnd = newText.length;
//                textarea.focus();
//            }, 0);
//        }
    }

    // renumber variables sequentially
//    const renumberVariables = (updatedText) => {
//        const matches = updatedText.match(/\{\{(\d+)\}\}/g) || [];
//        // console.log('Re-match: ', matches);
//        // let count = 1;
//        // const newText = updatedText.replace(/\{\{(\d+)\}\}/g, () => `{{${count++}}}`);
//        // setVariables((prev) => {
//        //     return matches.map((prevVariable, index) => {
//        //         return `{{${index + 1}}}`;
//        //     })
//        // });
//
//        const extractedNumbers = matches.map((match) => parseInt(match.replace(/[{}]/g, ""), 10));
//        console.log('extractedNumbers: ', extractedNumbers, variables);
//
//        // Filter existing variables & remove those missing in the textarea
//        const updatedVars = variables.filter((v) => extractedNumbers.includes(v.id));
//        console.log('updatedVars: ', updatedVars, updatedVars.sort((a, b) => a.id - b.id));
//        // Renumber variables sequentially
//        updatedVars.sort((a, b) => a.id - b.id).forEach((v, index) => (v.id = index + 1));
//        console.log('updatedVars2: ', updatedVars);
//
//        setVariables(updatedVars);
//
//        // Update textarea with renumbered variables
//        // let updatedText = rowData?.message_body;
//        matches.forEach((match, index) => {
//            updatedText = updatedText.replace(match, `{{${index + 1}}}`);
//        });
//        console.log('updatedText: ', updatedText);
//        return updatedText;
//    };

    const helpText = (
        <ul>
            <li>Variable parameters are missing or have mismatched curly braces. The correct format is \u007B\u007B1\u007D\u007D.</li>
            <li>Variable parameters contain special characters such as #, $, or %.</li>
            <li>Variable parameters are not sequential. For example, \u007B\u007B1\u007D\u007D, \u007B\u007B2\u007D\u007D, \u007B\u007B4\u007D\u007D, \u007B\u007B5\u007D\u007D are defined but \u007B\u007B3\u007D\u007D does not exist.</li>
            <li>Template contains too many variable parameters relative to the message length. You need to decrease the number of variable parameters or increase the message length.</li>
            <li>The message template cannot end with a parameter.</li>
        </ul>
    );



    return (
        <>
            {!isSpinner ? <>

                <Container className='mt-1'>
                    <Row className='mx-5 g-0'>
                        <Col lg={12} sm={12} xs={12}>
                            <Card className='h-100' style={{ border: "none" }}>
                                <Card.Body>
                                    <Row>
                                        <Col lg={12} sm={12} xs={12}>
                                            <Form.Group className='mx-2 mb-3'>
                                                <Form.Label className="form-view-label" htmlFor="formBasicName">
                                                    <b>Template name and language</b>
                                                </Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row className='mb-3'>
                                        <Col lg={6} sm={12} xs={12}>
                                            <Form.Group className='mx-2 mb-3'>
                                                <Form.Label className="form-view-label" htmlFor="formBasicTemplateName">
                                                    Template Name
                                                </Form.Label>
                                                <Form.Control
                                                    disabled={rowData?.id}
                                                    type="text"
                                                    name="name"
                                                    value={rowData?.name}
                                                    onChange={handleChange}
                                                    placeholder="Enter template name"
                                                    required
                                                    style={{ height: "36px" }}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6} sm={12} xs={12}>
                                            <Form.Group className='mb-2 mx-3'>
                                                <Form.Label className="form-view-label" htmlFor="formBasicLanguage">
                                                    Language
                                                </Form.Label>
                                                <Form.Select
                                                    // disabled={rowData?.id}
                                                    aria-label="select language"
                                                    name="language"
                                                    value={rowData?.language}
                                                    onChange={handleChange}
                                                    required
                                                    style={{ height: "36px" }}
                                                >
                                                    <option value="">Select Language</option>
                                                    <option value="en">English</option>
                                                    <option value="en_US">English (US)</option>
                                                    <option value="en_GB">English (UK)</option>
                                                    <option value="hi">Hindi</option>
                                                    <option value="ur">Urdu</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row >
                </Container >

                <Container className='mt-1'>
                    <Row className='mx-5 mb-5 g-0'>
                        <Col lg={12} sm={12} xs={12} className="mb-2">
                            <Card className='h-100' style={{ border: "none" }}>
                                <Card.Body>
                                    <Row>
                                        <Col lg={12} sm={12} xs={12}>
                                            <Form.Group className='mx-2 mb-3' >
                                                <Form.Label className="form-view-label" htmlFor="formBasicContent">
                                                    <b>Content </b> ( Fill in the header, body and footer sections of your template. )
                                                </Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row className='mb-3'>
                                        <Col lg={6} sm={12} xs={12}>
                                            <Form.Group className='mb-3 mx-3'>
                                                <Form.Label className="form-view-label" htmlFor="formBasicHeader">
                                                    Header
                                                </Form.Label>
                                                <Form.Select
                                                    aria-label="select language"
                                                    name="header"
                                                    value={rowData?.header}
                                                    onChange={handleChange}
                                                    style={{ height: "36px" }}
                                                >
                                                    <option value="">Select Header</option>
                                                    <option value="TEXT">Text</option>
                                                    <option value="IMAGE">Image</option>
                                                    <option value="DOCUMENT">Document</option>
                                                    <option value="VIDEO">Video</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>

                                        {rowData.header === 'TEXT' &&
                                            <Col lg={6} sm={12} xs={12}>
                                               
                                                <Form.Group className='mx-3 mb-3'>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                    <Form.Label className="form-view-label" htmlFor="formBasicHeaderText">
                                                        Header Text
                                                    </Form.Label>
                                                    <OverlayTrigger
                                                        placement="auto"
                                                        overlay={
                                                            <Popover id={`popover-positioned-auto`}>
                                                                <Popover.Body>
                                                                    <ul>
                                                                    <li>Max 60 characters.</li>
                                                                    <li>No new lines, emojis, or special characters.</li>
                                                                    </ul>
                                                                </Popover.Body>
                                                            </Popover>
                                                        }
                                                    >
                                                        <i className="fa-solid fa-circle-info text-secondary ms-1" style={{ cursor: "pointer" }}></i>
                                                    </OverlayTrigger>
                                                    </div>
                                                    <span className="text-muted me-1" style={{ fontSize: "0.85rem" }}>
                                                        {`${rowData?.header_text?.length || 0}/60`}
                                                    </span>
                                                    </div>
                                                    <Form.Control
                                                        type="text"
                                                        name="header_text"
                                                        value={rowData?.header_text}
                                                        onChange={handleChange}
                                                        placeholder="Enter text here..."
                                                        required
                                                        style={{ height: "36px" }}
                                                        maxLength={60}
                                                    />
                                                   
                                                </Form.Group>
                                            </Col>
                                        }
                                    </Row>

                                    <Row className='mb-3'>
                                        <Col lg={6} sm={12} xs={12}>
                                            {rowData.header === 'IMAGE' &&
                                                <>
                                                    <Form.Group className='mb-3 mx-3'>
                                                        <Form.Label>Upload Image</Form.Label> <Form.Text muted>(Image Supported: .jpg, .jpeg, .png)</Form.Text>
                                                        <Form.Control
                                                            required
                                                            type="file"
                                                            name="header_image_url"
                                                            accept="image/jpeg, image/png, image/jpg" // Allow only image files
                                                            onChange={handleFileChange}
                                                        />
                                                        <Form.Text>Maximum Size: 5MB</Form.Text>
                                                        {errorMessage && <><br /><Form.Text className="text-danger">{errorMessage}</Form.Text></>}
                                                    </Form.Group>
                                                    {selectedImage2 ?
                                                        <Image className='mx-3' variant="top" src={selectedImage2} thumbnail style={{ width: "15%" }}>
                                                        </Image>
                                                        :
                                                        selectedFiles &&
                                                        <Image className='mx-3' variant="top" src={URL.createObjectURL(selectedFiles)} thumbnail style={{ width: "15%" }}>
                                                        </Image>
                                                    }
                                                </>
                                            }

                                            {rowData.header === 'DOCUMENT' &&
                                                <>
                                                    <Form.Group className='mb-3 mx-3'>
                                                        <Form.Label>Upload Document</Form.Label> <Form.Text muted>(Document Supported: .pdf)</Form.Text>
                                                        <Form.Control
                                                            required
                                                            type="file"
                                                            name="header_document_url"
                                                            accept=".pdf" // Allow only PDF files
                                                            onChange={handleFileChange}
                                                        />
                                                        <Form.Text>Maximum Size: 100MB</Form.Text>
                                                        {errorMessage && <><br /><Form.Text className="text-danger">{errorMessage}</Form.Text></>}
                                                    </Form.Group>

                                                    {selectedDocument2 ?
                                                        <Form.Text className="text-muted mx-2">
                                                            <a href={selectedDocument2} target="_blank" rel="noopener noreferrer">
                                                                <i className="fa-solid fa-file-pdf mx-2" style={{ fontSize: "15px" }}></i>View PDF
                                                            </a>
                                                        </Form.Text>
                                                        :
                                                        selectedFiles &&
                                                        <Form.Text className="text-muted mx-2">
                                                            <a href={URL.createObjectURL(selectedFiles)} target="_blank" rel="noopener noreferrer">
                                                                <i className="fa-solid fa-file-pdf mx-2" style={{ fontSize: "15px" }}></i>{selectedFiles.name}</a>
                                                        </Form.Text>
                                                    }
                                                </>
                                            }

                                            {rowData.header === 'VIDEO' &&
                                                <>
                                                    <Form.Group className='mb-3 mx-3'>
                                                        <Form.Label>Upload Video</Form.Label> <Form.Text muted>(Video Supported: .mp4)</Form.Text>
                                                        <Form.Control
                                                            required
                                                            type="file"
                                                            name="header_video_url"
                                                            accept="video/mp4" // Allow only MP4 videos
                                                            onChange={handleFileChange}
                                                        />
                                                        <Form.Text>Maximum Size: 16MB</Form.Text>
                                                        {errorMessage && <><br /><Form.Text className="text-danger">{errorMessage}</Form.Text></>}
                                                    </Form.Group>
                                                    {selectedVideo2 ?
                                                        <video controls className='mx-3' style={{ width: "100%" }}>
                                                            <source src={selectedVideo2} type="video/mp4" />
                                                            Your browser does not support the video tag.
                                                        </video>

                                                        :
                                                        selectedFiles &&
                                                        <video controls className='mx-3' style={{ width: "100%" }}>
                                                            <source src={URL.createObjectURL(selectedFiles)} type="video/mp4" />
                                                            Your browser does not support the video tag.
                                                        </video>
                                                    }
                                                </>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className='mb-3'>
                                        <Col lg={12} sm={12} xs={12}>
                                            <Form.Group className='mx-3 mb-1'>
                                            <div className="d-flex justify-content-between align-items-center">
                                            <Form.Label className="form-view-label" htmlFor="formBasicBody">
                                                Body
                                                <OverlayTrigger
                                                        placement="auto"
                                                        overlay={
                                                            <Popover id={`popover-positioned-auto`}>
                                                                <Popover.Body>
                                                                    <ul>
                                                                    <li>Min 25 and max 1,024 characters.</li>
                                                                    <li>Cannot end with a variable.</li>
                                                                    </ul>
                                                                </Popover.Body>
                                                            </Popover>
                                                        }
                                                    >
                                                        <i className="fa-solid fa-circle-info text-secondary ms-1" style={{ cursor: "pointer" }}></i>
                                                    </OverlayTrigger>
                                            </Form.Label>      
                                            <span className="text-muted" style={{ fontSize: "0.85rem" }}>
                                                {`${rowData?.message_body?.length || 0}/1024`}
                                            </span>
                                        </div>
                                                <Form.Control
                                                    as="textarea"
                                                    name="message_body"
                                                    ref={bodyRef}
                                                    value={rowData?.message_body}
                                                    onChange={handleChange}
                                                    placeholder="type text here..."
                                                    required
                                                    rows={10}
                                                    maxLength={1024}
                                                />
                                               
                                            </Form.Group>
                                            <div className='mb-3 mx-3'>
                                            <Col lg={12} sm={12} xs={12} className='text-end mb-2'>
                                                <div className="toolbar">
                                                    <button className='format-text-btn' onClick={() => formatTextArea('*')} data-bs-toggle="tooltip" title="Bold"><i className="fa-solid fa-bold"></i></button>
                                                    <button className='format-text-btn' onClick={() => formatTextArea('_')} data-bs-toggle="tooltip" title="Italic"><i className="fa-solid fa-italic"></i></button>
                                                    <button className='format-text-btn' onClick={() => formatTextArea('~')} data-bs-toggle="tooltip" title="Strike-through"><i className="fa-solid fa-strikethrough"></i></button>
                                                    <button className='format-text-btn' onClick={() => formatTextArea('```')} data-bs-toggle="tooltip" title="Monospace"><i className="fa-solid fa-code"></i></button>
                                                       <button onClick={addVariable}  className='format-text-btn'>
                                <i className="fa-solid fa-plus"></i> <span className='fw-bold ps-2'>Add variable</span>
                              </button>

                                                    {/*<button className='format-text-btn' onClick={() => formatTextArea(null)}><i className="fa-solid fa-plus"></i> <span className='fw-bold ps-2'>Add variable</span></button>*/}
                                                    <OverlayTrigger
                                                        placement="auto"
                                                        overlay={
                                                            <Popover id={`popover-positioned-auto`}>
                                                                <Popover.Body>

                                                                    <ul>
                                                                        <li>Variable parameters are missing or have mismatched curly braces. The correct format is &#123;&#123;1&#125;&#125;.</li>
                                                                        <li>Variable parameters should not contain special characters such as #, $, or %.</li>
                                                                        <li>Variable parameters are not sequential. For example, &#123;&#123;1&#125;&#125;, &#123;&#123;2&#125;&#125;, &#123;&#123;4&#125;&#125;, &#123;&#123;5&#125;&#125; are defined but &#123;&#123;3&#125;&#125; does not exist.</li>
                                                                        <li>Template contains too many variable parameters relative to the message length. You need to decrease the number of variable parameters or increase the message length.</li>
                                                                        <li>The message template cannot end with a parameter.</li>
                                                                    </ul>

                                                                </Popover.Body>
                                                            </Popover>
                                                        }
                                                    >
                                                        <i className="fa-solid fa-circle-info text-secondary" style={{ cursor: "pointer" }}></i>
                                                    </OverlayTrigger>
                                                    </div>
                                                </Col>
 
                                                <Col xs={12}>
                                                { rowData?.message_body_example &&    
                                                    <span className="text-muted" style={{ fontSize: "0.85rem" }}>
                                                       <b> Samples for body content </b> <br/>
                                                        To help us review your message template, please add an example for each variable in your body text. Do not use real customer information. Cloud API hosted by Meta reviews templates and variable parameters to protect the security and integrity of our services.
                                                        </span>}
                                                    {
                                                        rowData?.message_body_example ?
                                                            <Table>
                                                                <thead>
                                                                    <tr>
                                                                        <th className='w-25'>Variable</th>
                                                                        <th className='w-25'>Value</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                               
                                                                       {rowData?.message_body_example?.map(
                                                                            (example, index) => (
                                                                            <tr key={index}>
                                                                                    <td>
                                                                                    {`{{${example.placeholder}}}`}
                                                                                    </td>
                                     
                                     
                                                                        <td>
                                                                            <Form.Control
                                                                            style={{ height: "36px" }}
                                                                            required
                                                                            type="text"
                                                                            name={`${example.placeholder}.value`}
                                                                            value={example.value || ""}
                                                                            onChange={(e) => {
                                                                                const updatedValue = e.target.value;
                                                                                setRowData((prevData) => ({
                                                                                ...prevData,
                                                                                message_body_example:
                                                                                    prevData.message_body_example.map(
                                                                                    (item) =>
                                                                                        item.placeholder ===
                                                                                        example.placeholder
                                                                                        ? {
                                                                                            ...item,
                                                                                            value: updatedValue,
                                                                                            }
                                                                                        : item
                                                                                    ),
                                                                                }));
                                                                            }}
                                                                            placeholder={`Enter content for {{${example.placeholder}}}`}
                                                                            />
                                                                </td>
                                                                        </tr>
                                                                    )
                                                                    )}
                                                                </tbody>
                                                            </Table>
                                                            : ''
                                                    }
                                                </Col>
                                              </div>
                                              </Col>
                                        <Col lg={6} sm={12} xs={12}>
                                            <Form.Group className='mx-3 mb-3'>
                                            <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <Form.Label className="form-view-label" htmlFor="formBasicFooter">
                                                    Footer
                                                </Form.Label>
                                                <OverlayTrigger
                                                    placement="auto"
                                                    overlay={
                                                        <Popover id={`popover-positioned-auto`}>
                                                            <Popover.Body>
                                                                <ul className="mb-0">
                                                                    <li>Max 60 characters.</li>
                                                                    <li>No newlines or emojis.</li>
                                                                </ul>
                                                            </Popover.Body>
                                                        </Popover>
                                                    }
                                                >
                                                    <i className="fa-solid fa-circle-info text-secondary ms-1" style={{ cursor: "pointer" }}></i>
                                                </OverlayTrigger>
                                            </div>
                                            <span className="text-muted" style={{ fontSize: "0.85rem" }}>
                                                {`${rowData?.footer?.length || 0}/60`}
                                            </span>
                                        </div>
                                                <Form.Control
                                                    type="text"
                                                    name="footer"
                                                    value={rowData?.footer}
                                                    onChange={handleChange}
                                                    placeholder="type text here..."
                                                    style={{ height: "36px" }}
                                                    maxLength={60}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>


                                    <Row className='mb-1'>
                                        <Col lg={12} sm={12} xs={12}>
                                            <Button className='mb-3 mx-3' variant="outline-secondary" onClick={handleAddButton}>
                                                <i className="fa-solid fa-plus mx-1"></i>Add Button
                                            </Button>
                                        </Col>
                                    </Row>

                                    <Row className='mb-1 mx-2'>
                                        <Col lg={12} sm={12} xs={12} className="mb-2">
                                            {buttons.map((button, index) => (
                                                <Row key={index} className='mb-3'>
                                                    <Col lg={3} sm={12} xs={12}>
                                                        <Form.Group className='mb-0'>
                                                            <Form.Label className="form-view-label">Type of action</Form.Label>
                                                            <Form.Select
                                                                value={button.type}
                                                                onChange={(e) => handleButtonChange(index, 'type', e.target.value)}
                                                                style={{ height: "36px" }}
                                                            >
                                                                <option value="">Select Type</option>
                                                                <option value="URL" disabled={getDisabledOptions('URL') && button.type !== 'URL'}>Visit Website</option>
                                                                <option value="PHONE_NUMBER" disabled={getDisabledOptions('PHONE_NUMBER') && button.type !== 'PHONE_NUMBER'}>Call Phone Number</option>
                                                                <option value="QUICK_REPLY">Quick Reply</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>

                                                    {(button.type === 'URL' || button.type === 'PHONE_NUMBER') && (
                                                        <Col lg={3} sm={12} xs={12}>
                                                            <Form.Group className='mb-0'>
                                                                <Form.Label className="form-view-label">Button Text</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={button.text}
                                                                    onChange={(e) => handleButtonChange(index, 'text', e.target.value)}
                                                                    placeholder="Enter button text..."
                                                                    style={{ height: "36px" }}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    )}

                                                    {button.type === 'URL' && (
                                                        <Col lg={3} sm={12} xs={12}>
                                                            <Form.Group className='mb-0'>
                                                                <Form.Label className="form-view-label">URL</Form.Label>
                                                                <Form.Control
                                                                    required
                                                                    type="text"
                                                                    value={button.url}
                                                                    onChange={(e) => handleButtonChange(index, 'url', e.target.value)}
                                                                    placeholder="https://www.example.com"
                                                                    style={{ height: "36px" }}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    )}

                                                    {button.type === 'PHONE_NUMBER' && (
                                                        <Col lg={3} sm={12} xs={12}>
                                                            <Form.Group className='mb-0'>
                                                                <Form.Label className="form-view-label">Phone Number</Form.Label>
                                                                <Form.Control
                                                                    required
                                                                    type="text"
                                                                    value={button.phone_number}
                                                                    onChange={(e) => handleButtonChange(index, 'phone_number', e.target.value.replace(/\D/g, ''))}
                                                                    placeholder="16467043595"
                                                                    style={{ height: "36px" }}
                                                                    isInvalid={button.phone_number && button.phone_number.length !== 12}
                                                                    maxLength={12}
                                                                />
                                                                   <Form.Control.Feedback type="invalid">
                                                                        Phone number must be 12 digits.
                                                                    </Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Col>
                                                    )}

                                                    {button.type === 'QUICK_REPLY' && (
                                                        <Col lg={6} sm={12} xs={12}>
                                                            <Form.Group className='mb-0'>
                                                                <Form.Label className="form-view-label">Text</Form.Label>
                                                                <Form.Control
                                                                    required
                                                                    type="text"
                                                                    value={button.text}
                                                                    onChange={(e) => handleButtonChange(index, 'text', e.target.value)}
                                                                    placeholder="Enter button text..."
                                                                    style={{ height: "36px" }}
                                                                    maxLength={25}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    )}

                                                    <Col lg={3} sm={12} xs={12} className='d-flex align-items-center mt-4 pt-2'>
                                                        <Button variant='danger' onClick={() => handleRemoveButton(index)}>
                                                            <i className="fa-solid fa-xmark" title='Remove'></i>
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            ))}
                                        </Col>
                                    </Row>


                                    <Row>
                                        <Col lg={12} sm={12} xs={12}>
                                            <hr></hr>
                                        </Col>
                                    </Row>

                                    <Row className='g-0 mb-2'>
                                        <Col lg={12} sm={12} xs={12} className="text-end mt-2">
                                            <Button className='mx-2' variant="light" onClick={handleBack} disabled={isSending}>
                                                Back
                                            </Button>
                                            <Button variant="outline-secondary" disabled={!isFormValid || isSending} onClick={handleSubmit}>
                                                {isSending ? 'Submitting...' : 'Submit for Review'}
                                            </Button>
                                        </Col>
                                    </Row>

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row >
                </Container >

            </>
                :
                <Container className='mt-1'>
                    <Row className='mx-5'>
                        <Col lg={12} sm={12} xs={12}>
                            <Card className='h-100' style={{ border: "none" }}>
                                <Card.Body>
                                    <Row className='mb-3'>
                                        <Col lg={12} sm={12} xs={12}>
                                            <div className="sk-cube-grid">
                                                <div className="sk-cube sk-cube1"></div>
                                                <div className="sk-cube sk-cube2"></div>
                                                <div className="sk-cube sk-cube3"></div>
                                                <div className="sk-cube sk-cube4"></div>
                                                <div className="sk-cube sk-cube5"></div>
                                                <div className="sk-cube sk-cube6"></div>
                                                <div className="sk-cube sk-cube7"></div>
                                                <div className="sk-cube sk-cube8"></div>
                                                <div className="sk-cube sk-cube9"></div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row >
                </Container >
            }

            <ToastContainer />
        </>
    )
}

export default MarketingTemplate;